exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-8db4753c] .dropdown-menu {\n\tmax-height: 650px;\n\toverflow-y: auto;\n}\n", ""]);

// exports
